import {
  Baby,
  Bank,
  Books,
  Brain,
  ChalkboardTeacher,
  ChartPie,
  GearSix,
  House,
  IdentificationCard,
  ListBullets,
  Notification,
  Student,
  Users,
  BagSimple,
  Lock,
} from 'phosphor-react';
// import DashboardPage from '../pages/dashboard';
import { ExtraMaterialsPage } from '../pages/extraMaterials';
import { Home } from '../pages/home';
import { InstitutionTeamsPage } from '../pages/institutions/teams';
import { InstitutionsPage } from '../pages/institutions/list';
import InstitutionsCreatePage from '../pages/institutions/list/create';
import InstitutionsEditPage from '../pages/institutions/list/edit';
import UserInstitutionPage from '../pages/institutions/adminUser';
import { NotificationsPage } from '../pages/notifications';
import NotificationsCreatePage from '../pages/notifications/create';
import NotificationsEditPage from '../pages/notifications/edit';
import NotificationsShowPage from '../pages/notifications/show';
import ProfilePage from '../pages/profile';
import { SecretariesPage } from '../pages/secretaries';
import SecretariesCreatePage from '../pages/secretaries/create';
import SecretariesEditPage from '../pages/secretaries/edit';
import GeneralSettingsPage from '../pages/settings/general';
import PoliticsPage from '../pages/settings/politics';
import TermsPage from '../pages/settings/terms';
import { TeachersPage } from '../pages/teachers';
import TeachersCreatePage from '../pages/teachers/create';
import TeachersEditPage from '../pages/teachers/edit';
import { ResponsiblePage } from '../pages/responsible';
import ResponsibleCreatePage from '../pages/responsible/create';
import ResponsibleEditPage from '../pages/responsible/edit';
import { TutorsPage } from '../pages/tutors';
import TutorsCreatePage from '../pages/tutors/create';
import TutorsEditPage from '../pages/tutors/edit';
import { UsersPage } from '../pages/users';
import UsersCreatePage from '../pages/users/create';
import UsersEditPage from '../pages/users/edit';
import InstitutionTeamsCreatePage from '../pages/institutions/teams/create';
import InstitutionTeamsEditPage from '../pages/institutions/teams/edit';
import InstitutionTeamsViewPage from '../pages/institutions/teams/view';
import { TeamStudentsPage } from '../pages/institutions/students';
import ExtraMaterialsCreatePage from '../pages/extraMaterials/create';
import ExtraMaterialsEditPage from '../pages/extraMaterials/edit';
import ExtraMaterialsViewPage from '../pages/extraMaterials/view';
import { ContentsModulesPage } from '../pages/contents/modules';
import ContentsModulesCreatePage from '../pages/contents/modules/create';
import ContentsModulesEditPage from '../pages/contents/modules/edit';
import { ModulesWeeksPage } from '../pages/contents/weeks';
import ModulesWeeksCreatePage from '../pages/contents/weeks/create';
import ModulesWeeksEditPage from '../pages/contents/weeks/edit';
import { ResponsibleChildrensPage } from '../pages/contents/childrens';
import ResponsibleChildrensCreatePage from '../pages/contents/childrens/create';
import ResponsibleChildrensEditPage from '../pages/contents/childrens/edit';
import { ContentsCategoriesPage } from '../pages/contents/categories';
import ContentsCategoriesCreatePage from '../pages/contents/categories/create';
import ContentsCategoriesEditPage from '../pages/contents/categories/edit';
import { WeeksMeetingsPage } from '../pages/contents/meetings';
import WeeksMeetingsCreatePage from '../pages/contents/meetings/create';
import WeeksMeetingsEditPage from '../pages/contents/meetings/edit';
import WeeksMeetingsViewPage from '../pages/contents/meetings/view';
import TeamStudentsCreatePage from '../pages/institutions/students/create';
import TeamStudentsEditPage from '../pages/institutions/students/edit';
import TeamStudentsViewPage from '../pages/institutions/students/view';
import { TopicsPage } from '../pages/topics';
import { AssessmentsPage } from '../pages/assessments';
import { StudentsPage } from '../pages/students';
import StudentsEditPage from '../pages/students/edit';
import StudentsCreatePage from '../pages/students/create';
import { UserAccessManagementPage, PermissionLogsPage } from '../pages/permissions';
import { TemplatesPage } from '../pages/templates';
import TemplateCreatePage from '../pages/templates/create';
import TemplateEditPage from '../pages/templates/edit';
import { InstitutionTemplateLinkPage } from '../pages/templates/link';
import { MaterialModulesPage } from '../pages/modules';

export const PrivateRoutes = [
  {
    name: 'Perfil',
    path: '/profile',
    component: ProfilePage,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    showSidebar: false,
    localeSidebar: 'top',
    icon: House,
  },
  {
    name: 'Dashboard',
    path: '/',
    component: Home,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    showSidebar: true,
    localeSidebar: 'top',
    icon: House,
  },
  {
    name: 'Tutores',
    path: '/tutors',
    component: TutorsPage,
    componentCreate: TutorsCreatePage,
    componentEdit: TutorsEditPage,
    componentShow: false,
    showSidebar: true,
    localeSidebar: 'top',
    icon: Student,
  },
  {
    name: 'Secretarias',
    path: '/secretaries',
    component: SecretariesPage,
    componentCreate: SecretariesCreatePage,
    componentEdit: SecretariesEditPage,
    componentShow: false,
    showSidebar: true,
    localeSidebar: 'top',
    icon: IdentificationCard,
  },
  {
    name: 'Professores',
    path: '/teachers',
    component: TeachersPage,
    componentCreate: TeachersCreatePage,
    componentEdit: TeachersEditPage,
    componentShow: false,
    showSidebar: true,
    localeSidebar: 'top',
    icon: ChalkboardTeacher,
  },
  {
    name: 'Instituições',
    path: '/institutions/list',
    component: InstitutionsPage,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    showSidebar: true,
    localeSidebar: 'top',
    icon: Bank,
    isParentMenu: true,
  },
  {
    name: 'Instituições',
    path: '/institutions/list',
    component: InstitutionsPage,
    componentCreate: InstitutionsCreatePage,
    componentEdit: InstitutionsEditPage,
    componentShow: false,
    showSidebar: false,
    localeSidebar: 'top',
    parentMenu: 'Instituições',
    isParentMenu: true,
  },
  {
    name: 'Alunos',
    path: '/students',
    component: StudentsPage,
    componentCreate: StudentsCreatePage,
    componentEdit: StudentsEditPage,
    componentShow: false,
    showSidebar: false,
    localeSidebar: 'top',
    parentMenu: 'Instituições',
    icon: Baby,
  },
  {
    name: 'Responsáveis',
    path: '/responsible',
    component: ResponsiblePage,
    componentCreate: ResponsibleCreatePage,
    componentEdit: ResponsibleEditPage,
    componentShow: false,
    showSidebar: false,
    localeSidebar: 'top',
    parentMenu: 'Instituições',
    icon: Baby,
  },
  {
    name: 'filhos dos responsáveis ',
    path: '/responsible/:parentId',
    component: ResponsibleChildrensPage,
    componentCreate: ResponsibleChildrensCreatePage,
    componentEdit: ResponsibleChildrensEditPage,
    componentShow: false,
    showSidebar: false,
    localeSidebar: 'top',
  },
  {
    name: 'Turmas',
    path: '/institutions/list/:institutionId/teams',
    component: InstitutionTeamsPage,
    componentCreate: InstitutionTeamsCreatePage,
    componentEdit: InstitutionTeamsEditPage,
    componentShow: InstitutionTeamsViewPage,
    showSidebar: false,
    localeSidebar: 'top',
  },
  {
    name: 'Avaliações',
    path: '/assessments/list',
    component: AssessmentsPage,
    componentCreate: AssessmentsPage,
    componentEdit: AssessmentsPage,
    componentShow: false,
    showSidebar: true,
    localeSidebar: 'top',
    icon: Brain,
  },
  {
    name: 'Turmas',
    path: '/institutions/list/:institutionId/teams',
    component: InstitutionTeamsPage,
    componentCreate: InstitutionTeamsCreatePage,
    componentEdit: InstitutionTeamsEditPage,
    componentShow: false,
    showSidebar: false,
    localeSidebar: 'top',
  },
  {
    name: 'Alunos',
    path: '/institutions/list/:institutionId/teams/:teamId/students',
    component: TeamStudentsPage,
    componentCreate: TeamStudentsCreatePage,
    componentEdit: TeamStudentsEditPage,
    componentShow: TeamStudentsViewPage,
    showSidebar: false,
    localeSidebar: 'top',
  },
  {
    name: 'Tópicos',
    path: '/topics',
    component: TopicsPage,
    componentCreate: TopicsPage,
    componentEdit: TopicsPage,
    componentShow: false,
    showSidebar: true,
    localeSidebar: 'top',
    icon: ChartPie,
  },
  {
    name: 'Conteúdos',
    path: '/contents',
    component: false,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    showSidebar: true,
    localeSidebar: 'top',
    icon: ListBullets,
    isParentMenu: true,
  },
  {
    name: 'Módulos',
    path: '/contents/modules',
    component: ContentsModulesPage,
    componentCreate: ContentsModulesCreatePage,
    componentEdit: ContentsModulesEditPage,
    componentShow: false,
    isChildrenMenu: true,
    parentMenu: 'Conteúdos',
    showSidebar: false,
  },
  {
    name: 'Semanas',
    path: '/contents/modules/:moduleId/weeks',
    component: ModulesWeeksPage,
    componentCreate: ModulesWeeksCreatePage,
    componentEdit: ModulesWeeksEditPage,
    componentShow: false,
    showSidebar: false,
    localeSidebar: 'top',
  },
  {
    name: 'Encontros',
    path: '/contents/modules/:moduleId/weeks/:weekId/meetings',
    component: WeeksMeetingsPage,
    componentCreate: WeeksMeetingsCreatePage,
    componentEdit: WeeksMeetingsEditPage,
    componentShow: WeeksMeetingsViewPage,
    showSidebar: false,
    localeSidebar: 'top',
  },
  {
    name: 'Categorias',
    path: '/contents/categories',
    component: ContentsCategoriesPage,
    componentCreate: ContentsCategoriesCreatePage,
    componentEdit: ContentsCategoriesEditPage,
    componentShow: false,
    isChildrenMenu: true,
    parentMenu: 'Conteúdos',
    showSidebar: false,
  },
  {
    name: 'Materiais Extras',
    path: '/extraMaterials',
    component: ExtraMaterialsPage,
    componentCreate: ExtraMaterialsCreatePage,
    componentEdit: ExtraMaterialsEditPage,
    componentShow: ExtraMaterialsViewPage,
    showSidebar: true,
    localeSidebar: 'top',
    icon: Books,
  },
  {
    name: 'Templates',
    path: '/templates',
    component: false,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    showSidebar: true,
    localeSidebar: 'top',
    icon: Books,
    isParentMenu: true,
  },
  {
    name: 'Gestão de Templates',
    path: '/templates/list',
    component: TemplatesPage,
    componentCreate: TemplateCreatePage,
    componentEdit: TemplateEditPage,
    componentShow: false,
    isChildrenMenu: true,
    parentMenu: 'Templates',
    showSidebar: false,
  },
  {
    name: 'Vincular Templates',
    path: '/templates/link',
    component: InstitutionTemplateLinkPage,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    isChildrenMenu: true,
    parentMenu: 'Templates',
    showSidebar: false,
  },
  {
    name: 'Módulos de Materiais',
    path: '/modules',
    component: MaterialModulesPage,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    isChildrenMenu: true,
    parentMenu: 'Templates',
    showSidebar: false,
  },
  {
    name: 'Notificações',
    path: '/notifications',
    component: NotificationsPage,
    componentCreate: NotificationsCreatePage,
    componentEdit: NotificationsEditPage,
    componentShow: NotificationsShowPage,
    showSidebar: true,
    localeSidebar: 'top',
    icon: Notification,
  },
  {
    name: 'Usuários',
    path: '/users',
    component: UsersPage,
    componentCreate: UsersCreatePage,
    componentEdit: UsersEditPage,
    componentShow: false,
    showSidebar: true,
    localeSidebar: 'top',
    icon: Users,
  },
  {
    name: 'Permissões',
    path: '/permissions',
    component: false,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    showSidebar: true,
    localeSidebar: 'top',
    icon: Lock,
    isParentMenu: true,
  },
  {
    name: 'Gerenciar Acessos',
    path: '/permissions/list',
    component: UserAccessManagementPage,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    isChildrenMenu: true,
    parentMenu: 'Permissões',
    showSidebar: false,
  },
  {
    name: 'Ver Histórico de Alterações',
    path: '/permissions/logs',
    component: PermissionLogsPage,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    isChildrenMenu: true,
    parentMenu: 'Permissões',
    showSidebar: false,
  },
  {
    name: 'Configurações',
    path: '/config',
    component: false,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    showSidebar: true,
    localeSidebar: 'top',
    icon: GearSix,
    isParentMenu: true,
  },
  {
    name: 'Dados gerais',
    path: '/settings/general',
    component: GeneralSettingsPage,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
    showSidebar: false,
  },
  {
    name: 'Termos de uso',
    path: '/settings/terms',
    component: TermsPage,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
    showSidebar: false,
  },
  {
    name: 'Políticas de privacidade',
    path: '/settings/politics',
    component: PoliticsPage,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    isChildrenMenu: true,
    parentMenu: 'Configurações',
    showSidebar: false,
  },
  {
    name: 'Minha instituição',
    path: '/user/institutions',
    component: UserInstitutionPage,
    componentCreate: false,
    componentEdit: false,
    componentShow: false,
    showSidebar: true,
    icon: BagSimple,
    localeSidebar: 'top',
  },
];
